import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../components/modals/deleteModal";
import EnableDisableModal from "../../../components/modals/enableDisableModal";
import DeletedPopUp from "../../../components/popups/DeletedPopUp";
import EnabledDisabledPopUp from "../../../components/popups/EnabledDisabledPopUp";
import {
  enableDisableHeadQuarter,
  fieldForceHeadQuarterDelete,
} from "../../../redux/actions/fieldForceAction";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const FieldForceHeadQuarterListTableData = ({
  data,
  index,
  fetchHeadQuarterList,
  currentPage,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [onEnableShow, setOnEnableShow] = useState(false);
  const [deleteShow, setDeleteShow] = useState(false);
  const [deletedPop, setDeletedPop] = useState(false);
  const [enabledDisable, setEnabledDisable] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showErrorPopup1, setShowErrorPopup1] = useState(false);
  const [showErrorMsg1, setShowErrorMsg1] = useState("");
  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Field Force" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const enableDisableFunc = (id) => {
    console.log(id);
    dispatch(
      enableDisableHeadQuarter(
        data?.id,
        onEnableDisableSuccess,
        onEnableDisableError
      )
    );
  };

  const onEnableDisableSuccess = (data) => {
    console.log(data);
    setOnEnableShow(false);
    setEnabledDisable(true);
    const timeOutFnc = () => {
      setEnabledDisable(false);
      fetchHeadQuarterList();
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onEnableDisableError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const delFunc = (id) => {
    dispatch(fieldForceHeadQuarterDelete(data?.id, onDelSuccess, onDelError));
  };

  const onDelSuccess = (data) => {
    console.log(data);
    setDeleteShow(false);
    setDeletedPop(true);

    const timeOutFnc = () => {
      setDeletedPop(false);
      fetchHeadQuarterList();
    };

    setTimeout(timeOutFnc, 2000);
  };
  const closeErrorPopup1 = () => {
    setShowErrorPopup1(false);
  };

  const onDelError = (err) => {
    console.log(err);
    setShowErrorPopup1(true);
    const str1 = err.data.message;
    const str_modify1 = str1.charAt(0).toUpperCase() + str1.slice(1);
    setShowErrorMsg1(str_modify1);
  };

  const renderDistrictsTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {data?.headQuaterDistricts?.map((ele, index) => (
        <span key={index}>
          {index ? <span className="mx-1 color_b0b3c7">|</span> : ""}
          {ele?.district?.name ? ele?.district?.name : "--"}
        </span>
      ))}
    </Tooltip>
  );

  return (
    <tr className="table-rows1 text-nowrap" key={index}>
      <td className="table-each-row-data  ">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data.code}</td>
      <td className="table-each-row-data">{data?.name}</td>
      <td className="table-each-row-data">{data?.state?.name}</td>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={renderDistrictsTooltip}
      >
        <td
          className="table-each-row-data text-truncate"
          style={{ maxWidth: "200px" }}
        >
          {data?.headQuaterDistricts?.length > 0 &&
            data?.headQuaterDistricts?.map((ele, index) => {
              return (
                <span className="slice-word" key={index}>
                  <span style={{ color: "#B0B3C7" }}>{index ? " | " : ""}</span>
                  {ele?.district?.name}
                </span>
              );
            })}
        </td>
      </OverlayTrigger>
      {data.status == true ? (
        <td className="table-each-row-data color-green">Active</td>
      ) : (
        <td className="table-each-row-data color-danger">Inactive</td>
      )}
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/field-force/head-quarter/view/${data?.id}`)
            }
          >
            {"view"}
          </button>
          {(user_type == "super_user" && userData?.write) ||
          user_type == "vendor" ? (
            <>
              <span className="vr  vr_line mt-1 "></span>
              <button
                className="button-edit1"
                type="button"
                onClick={() =>
                  navigate(`/field-force/head-quarter/edit/${data?.id}`)
                }
              >
                {"edit"}
              </button>
              <span className="vr  vr_line mt-1 "></span>
              <button
                className={
                  data.status == true ? `button-disable` : `button-enable`
                }
                type="button"
                color={"green"}
                onClick={() => setOnEnableShow(true)}
              >
                {data.status == true ? "disable" : "enable"}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </td>
      <DeleteModal
        title={`this Field Force Head Quater - ${data?.code}`}
        delFunc={delFunc}
        show={deleteShow}
        handleClose={() => setDeleteShow(false)}
      />
      <DeletedPopUp
        title={`this Field Force Head Quater - ${data?.code}`}
        show={deletedPop}
      />
      <EnableDisableModal
        show={onEnableShow}
        handleClose={() => setOnEnableShow(false)}
        status={data?.status}
        id={data?.id}
        enableDisableFunc={enableDisableFunc}
        title={`Field Force Head Quarter - ${data?.code} ?`}
      />
      <EnabledDisabledPopUp
        title={`Field Force Head Quarter - ${data?.code}`}
        show={enabledDisable}
        status={data.status}
      />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <ErrorPopup
        show={showErrorPopup1}
        title={showErrorMsg1}
        handleClose={closeErrorPopup1}
      />
    </tr>
  );
};

export default FieldForceHeadQuarterListTableData;
